export const claimsSubscriberHistoryColumns = [
  'id',
  'fk_billing_provider_id',
  'fk_claims_meta_data_id',
  'subscriber_relationship',
  'subscriber_first_name',
  'subscriber_last_name',
  'subscriber_middle_name',
  'subscriber_108',
  'subscriber_code',
  'subscriber_dob_format',
  'subscriber_dob',
  'subscriber_gender',
  'subscriber_marital_status',
  'patient_relationship',
  'patient_first_name',
  'patient_last_name',
  'patient_middle_name',
  'patient_108',
  'patient_code',
  'subscriber_addr_street',
  'subscriber_addr_city',
  'subscriber_addr_state',
  'subscriber_addr_zip',
  'subscriber_hl_01',
  'subscriber_hl_02',
  'subscriber_hl_03',
  'subscriber_hl_04',
  'subscriber_payer_responsibility_code',
  'subscriber_id_type',
  'subscriber_group_policy_id',
  'subscriber_payer_name',
  'subscriber_claim_filing_indicator',
  'patient_relationship_status_code',
  'patient_hl_01',
  'patient_hl_02',
  'patient_hl_03',
  'patient_hl_04',
  'payer_name',
  'payer_id_type',
  'payer_entity_type',
  'payer_id_code_qualifier',
  'payer_plan_id',
  'payer_addr_street',
  'payer_addr_city',
  'payer_addr_state',
  'payer_addr_zip',
  'payer_ref_type_01',
  'payer_ref_code_01',
  'payer_ref_type_02',
  'payer_ref_code_02',
  'secondary_payer_name',
  'secondary_payer_id_type',
  'secondary_payer_entity_type',
  'secondary_payer_plan_id',
  'secondary_payer_plan_code',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
  'meta_lineage_content_hash',
];
